export default __webpack_public_path__ + "static/media/element_76.a20f38ec.webp";